import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-konfortify-card-basic.js';

const buttonHtml = buttonPrimary({
  text: 'Shop now',
  backgroundColor: '#000000',
  color: '#FFFFFF',
  radius: 0,
  show: false,
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div
    data-attribute="konfortify-card-basic"
    class="konfortify-card-basic container"
    data-image-position="left"
    data-image-show="true"
  >
    <div data-attribute="konfortify-card-basic__layout" class="konfortify-card-basic__layout">
      <div
        data-attribute="konfortify-card-basic__media"
        class="konfortify-card-basic__media"
        data-show="true"
      >
        <img
          data-attribute="konfortify-card-basic__image"
          src="https://cdn.skyfastimg.com/images/2026/08/17/image-6a82db547762b6cd967cbf1b.webp?w=1000"
          alt="Ortho-Max recommended by experts"
        />
      </div>

      <div
        data-attribute="konfortify-card-basic__content-box"
        class="konfortify-card-basic__content-box"
        data-background-color="#E2ECFD"
        data-text-color="#000000"
        style="--content-background-color: #E2ECFD; --content-text-color: #000000"
      >
        <div
          data-attribute="konfortify-card-basic__content"
          class="konfortify-card-basic__content"
        >
          <h2 style="text-align:center;"><span style="font-size:40px;"><strong>Recommended by experts &ndash; for health and well-being.</strong></span></h2>
          <p style="text-align: center">
            <strong>Ortho-Max™</strong> &ndash; More than a shoe. Expertly recommended for
            foot health, comfort, and pain-free walking.
          </p>
        </div>
        <div data-attribute="konfortify-card-basic__button" class="konfortify-card-basic__button">
          ${buttonHtml}
        </div>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FFFFFF',
  textColor: '#000000',
});
